export default class QueriesController {
  #api;
  #paths;
  constructor(requestService, paths) {
    this.#api = requestService;
    this.#paths = paths;
  }

  async fethAvatarImagesBank() {
    try {
      const path = this.#paths.avatar.AvatarBankPath;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, The avatar list could not be obtained.');
    }
  }

  async fetchRankingAndLevelInformation({ childId }) {
    try {
      const path = this.#paths.ranking.RankingInfoPath(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Ranking and level information could not be obtained.');
    }
  }

  async fetchCoinsInformation({ childId }) {
    try {
      const path = this.#paths.progress.childCoinsInformation(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error(
        '[Query]: Sorry, We have not been able to obtain the information of the coins.',
      );
    }
  }

  async fetchAvatarBychild({ childId }) {
    try {
      const path = this.#paths.avatar.AvatarSelectionPath(childId);
      const { data } = await this.#api.Get(path);
      return data.avatar;
    } catch (error) {
      throw new Error("[Query]: Sorry, Unable to obtain the child's avatar.");
    }
  }

  async fetchRewards({ childId }) {
    try {
      const path = this.#paths.rewards.rewards(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain rewards.');
    }
  }

  async fetchDefaultRewards() {
    try {
      const path = this.#paths.rewards.defaultRewards;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      console.log(error);
      throw new Error('[Query]: Sorry, Unable to obtain default rewards.');
    }
  }

  async fetchChildLockedBadges({ childId }) {
    try {
      const path = this.#paths.badges.lockedBadges(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error("[Query]: Sorry, Unable to obtain child's locked badges.");
    }
  }

  async fetchChildUnlockedBadges({ childId }) {
    try {
      const path = this.#paths.badges.unlockedBadges(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error("[Query]: Sorry, Unable to obtain child's unlocked badges.");
    }
  }

  async fetchQuestionsRate() {
    try {
      const path = this.#paths.rate.questions;
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain rate questions.');
    }
  }

  async fetchWeekAnswersRate({ childId }) {
    try {
      const path = this.#paths.rate.weekAnswers(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, Unable to obtain rate answers.');
    }
  }

  async fetchChildCoinsValues({ childId }) {
    try {
      const path = this.#paths.coinsUpdater.coinsValues(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error("[Query]: Sorry, Unable to obtain child's coins.");
    }
  }

  async fetchChildCoinsPending({ childId }) {
    try {
      const path = this.#paths.coinsApproved.childCoinsPending(childId);
      const { data } = await this.#api.Get(path);
      return data;
    } catch (error) {
      throw new Error("[Query]: Sorry, Unable to obtain child's coins pending.");
    }
  }
}
